<template>
  <div class="p-5 sm:p-10 ">

    <div>
      <h1 class="text-2xl sm:text-3xl font-semibold text-gradient-blue inline-block">Getting Started with FOREVER!</h1>
      <p class="text-charcoal-400 text-base sm:text-lg leading-tight">Start your forever journey by learning everything FOREVER has to offer. </p>
    </div>

    <help-videos-list :to-video="startVideo" class="mt-4" />

    <u-divider class="my-4" />
    <p class="text-right sm:-mb-6 text-sm">
      <span class="font-semibold">Need more help?</span>
      Visit the <u-link :to="EXTERNAL_URLS.helpCenter" :external="true" target="_blank">FOREVER Help Center</u-link>
    </p>
  </div>
</template>

<script setup>

  const props = defineProps({
    toVideo: Object,
  });

  const startVideo = ref(props.toVideo);

</script>
